import { ArrowBigDown, type LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { type WorkflowStep } from "~/api/types";
import { Button } from "~/atoms/button";
import { getApprovalStatus } from "~/helpers/documentPermissions";

interface Props {
  step: WorkflowStep;
  isSubmitting: boolean;
  onNextStep: () => void;
  className?: string;
  size?: React.ComponentProps<typeof Button>["size"];
  icon?: LucideIcon;
}

export function WorkflowNextStepButton({
  step,
  isSubmitting,
  onNextStep,
  className,
  size,
  icon: Icon = ArrowBigDown,
}: Props) {
  const { t } = useTranslation();
  const { isWaitingForApprovals, approvedCount, totalCount } =
    getApprovalStatus(step);

  return (
    <Button
      variant="outline"
      size={size}
      onClick={onNextStep}
      disabled={isSubmitting || isWaitingForApprovals}
      className={className}
    >
      <Icon />
      {isWaitingForApprovals
        ? t(($) => $.commons.workflow.waitingForApprovals, {
            approvedCount,
            totalCount,
          })
        : t(($) => $.commons.workflow.nextStep)}
    </Button>
  );
}
